import { css } from "lit-element"

export const styles = css`
	:host {
	margin-bottom: 5.5rem;
}

	.first-post {
		border-radius: 0.3125rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: flex-start;
		overflow: hidden;
		position: relative;
		padding: 6.69rem 3.87rem;
		container-name: single-post;
		box-sizing: border-box;
		width: 100%;
		gap: 1.5rem;
	}

	.single-post {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		overflow: hidden;
		position: relative;
		container-name: single-post;
		box-sizing: border-box;
	}

.first-post	h2 {
		color: var(--e-global-color-secondary);
		font-size: 3.125rem;
	}

	.first-post p {
		color: #FCF7C5;
		font-size: 1.125rem;
	}

	.first-post span {
		color:#FCF7C5;
		font-size: 1rem;
}

	.first-post a {
		color: var(--e-global-color-secondary);
		font-family: var(--headings-font-family);
		text-decoration: underline;
		font-size: 1.625rem;
	}

	.first-post .img-container, .first-post .content-container {
	width: 50%;
}

	.img-container {
		width: 100%;
		height: 100%;
		position: relative;
		border-radius: 0.3125rem;
		overflow: hidden;
	}

	.loading {
		background-color: #f4f4f4;
		border-radius: 1.875rem;
		height: 100%;
		width: 100%;
		display: block;
		position: relative;
	}

	img {
		border-radius: 0.3125rem;
		overflow: visible;
		overflow-clip-margin: unset;
		object-fit: contain;
		height: 100%;
		width: 100%;
	}

	.single-post .content-container {
		width: 100%;
	}

	.single-post span {
	  color: var(--e-global-color-accent);
		font-size: 1rem;
		
		margin-top:0.5rem;
		display:inline-block;
	}

	.single-post h2 {
		font-size: 2.375rem;
		color: var(--e-global-color-primary);
	}

	.single-post p {
		color: var(--e-global-color-text);
		font-size: 1.125rem;
		width:100%;
		line-break: anywhere:
	}

	.single-post a {
		color: var(--e-global-color-primary);
		font-family: var(--headings-font-family);
		text-decoration: underline;
		font-size: 1.625rem;
	}

	h2 {
		font-size: 1.75rem;
		font-style: normal;
		font-weight: 400;
		line-height: 120%; /* 2.1rem */
		font-family: var(--headings-font-family);
		margin: 0;
	}

	@media screen and (max-width: 1030px) {
		.first-post {
			flex-direction: column;
			padding: 3.87rem 1rem;
			background-color: var(--e-global-color-primary);
		}

		.first-post .img-container, .first-post .content-container {
			width: 100%;
		}

		.single-post {
			flex-direction: column;
			padding: 1rem;
			width: 100%;
		}

		.single-post h2 {
			font-size: 1.75rem;
		}

		.single-post p {
			font-size: 1rem;
			line-break: anywhere;
		}

		.single-post a {
			font-size: 1.25rem;
		}

			:host {
			margin-bottom: 3rem;
		}
	}
}`
